export default __webpack_public_path__ + "static/Relationship1-aa370806b0c7b431bd83d8acd41b86fe.png";